import {
  CalendarCheck, Clock, Users, HandHeart, ShieldCheck, GraduationCap,
  CalendarDays, BookOpen, Apple,
} from "lucide-react";
import { Reveal, Chapter } from "@/components/Shared";

const PILLARS = [
  { icon: CalendarCheck, title: "Open 7 Days a Week", testId: "pillar-open-7-days" },
  { icon: Clock, title: "Convenient 6 AM–6 PM Hours", testId: "pillar-hours" },
  { icon: Users, title: "Ages 2–12", testId: "pillar-ages" },
  { icon: HandHeart, title: "Child Care Scholarships Accepted", testId: "pillar-scholarships" },
  { icon: ShieldCheck, title: "Safe & Nurturing Environment", testId: "pillar-safe" },
  { icon: GraduationCap, title: "Educational Activities", testId: "pillar-educational" },
  { icon: CalendarDays, title: "Weekend Care", testId: "pillar-weekend" },
  { icon: BookOpen, title: "Homework Support", testId: "pillar-homework" },
  { icon: Apple, title: "Snacks & Milk Provided*", testId: "pillar-snacks" },
];

const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="relative bg-cream/60 py-24 sm:py-32 overflow-hidden">
    <p className="pointer-events-none absolute -top-6 left-0 right-0 text-center font-serif text-[18vw] leading-none text-outline opacity-[0.07] select-none" aria-hidden="true">
      Why Us
    </p>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mx-auto max-w-2xl text-center flex flex-col items-center">
        <Chapter num="06" label="Why Families Choose Us" />
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.12] text-deepteal-dark">
          Nine reasons Halethorpe families <em className="italic text-terracotta">feel at home</em> here.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="pillars-grid">
        {PILLARS.map((p, i) => (
          <Reveal key={p.testId} delay={0.05 * i}>
            <div
              data-testid={p.testId}
              className="group flex h-full items-center gap-4 rounded-2xl border border-amber-900/10 bg-white/85 px-6 py-5 backdrop-blur transition-all duration-500 hover:-translate-y-1 hover:border-terracotta/40 hover:shadow-xl hover:shadow-terracotta/10"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-deepteal text-amber-200 transition-colors duration-500 group-hover:bg-terracotta group-hover:text-amber-50">
                <p.icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <p className="text-sm sm:text-[15px] font-bold text-deepteal-dark">{p.title}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-6 text-center text-xs text-slate-500">
          *Snacks and milk are provided as applicable. Meal and snack offerings may vary.
        </p>
      </Reveal>
    </div>
  </section>
);

export default WhyUs;
